import Contact from "#components/Contact";
import { CurvedDivider } from "#components/CurvedDivider";
import { CaseStudyGallery } from "#sections/CaseStudyGallery";
import React from "react";

function CaseStudiesPage() {
  return (
    <>
      <CaseStudyGallery />

      <CurvedDivider flip />

      <Contact />
    </>
  );
}
export default CaseStudiesPage;
